import { render } from "./LiteraturePage.vue?vue&type=template&id=be519fdc&scoped=true"
import script from "./LiteraturePage.vue?vue&type=script&lang=js"
export * from "./LiteraturePage.vue?vue&type=script&lang=js"

import "./LiteraturePage.vue?vue&type=style&index=0&id=be519fdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be519fdc"]])

export default __exports__